import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { legalIndex, legalDocs, site } from "../mock";
import Seo, { breadcrumbLd } from "../components/Seo";

const Foot = () => (
  <footer className="lg-footer">
    {site.company} {"\u00b7 "}
    {site.updated} {"\u00b7 "}
    <Link to="/contact">Contact</Link> {"\u00b7 "}
    <a
      className="inz-support-link"
      href="https://royalelite.support"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="support-portal-link"
    >
      Support
    </a>{" "}
    {"\u00b7 "}
    <Link to="/data-deletion">Delete my data</Link> {"\u00b7 "}
    <Link to="/admin/login" rel="nofollow">
      Admin
    </Link>
  </footer>
);

export const LegalIndex = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="lg-main">
      <Seo
        title="Legal &amp; policies | InZoRAH"
        description="Privacy policy, terms of service, subscription and refunds, health disclaimer and affiliate disclosure for the InZoRAH ingredient app."
        path="/legal"
        jsonLd={breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Legal", path: "/legal" },
        ])}
      />
      <p className="lg-brand">{"InZoRAH \u00b7 Legal"}</p>
      <h1 className="lg-h1">The fine print.</h1>
      <p className="lg-blurb">
        Short, readable and honest. These terms apply to your use of InZoRAH.
      </p>
      <hr className="lg-hr" />
      <ul className="lg-list">
        {legalIndex.map((d) => (
          <li key={d.slug}>
            <Link to={`/legal/${d.slug}`}>
              <strong>{d.title}</strong>
              <span>{d.blurb}</span>
            </Link>
          </li>
        ))}
      </ul>
      <p className="lg-back">
        <Link to="/contact">Contact us</Link> {"\u00b7 "}
        <Link to="/data-deletion">Delete your account &amp; data</Link> {"\u00b7 "}
        <Link to="/">Back to InZoRAH</Link>
      </p>
      <Foot />
    </main>
  );
};

export const LegalDoc = () => {
  const { slug } = useParams();
  const doc = legalDocs[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!doc) {
    return (
      <main className="lg-main">
        <p className="lg-brand">InZoRAH</p>
        <h1 className="lg-h1">Page not found</h1>
        <p className="lg-blurb">That legal page does not exist.</p>
        <hr className="lg-hr" />
        <p>
          <Link to="/legal">All legal pages</Link>
        </p>
        <Foot />
      </main>
    );
  }

  return (
    <main className="lg-main">
      <Seo
        title={`${doc.title} | InZoRAH`}
        description={doc.blurb}
        path={`/legal/${slug}`}
        jsonLd={breadcrumbLd([
          { name: "Home", path: "/" },
          { name: "Legal", path: "/legal" },
          { name: doc.title, path: `/legal/${slug}` },
        ])}
      />
      <p className="lg-brand">InZoRAH</p>
      <h1 className="lg-h1">{doc.title}</h1>
      <p className="lg-blurb">{doc.blurb}</p>
      <hr className="lg-hr" />
      {doc.sections.map((s) => (
        <section key={s.h}>
          <h2 className="lg-h2">{s.h}</h2>
          {s.p.map((t, i) => (
            <p key={i} className="lg-p">
              {t}
            </p>
          ))}
        </section>
      ))}
      <hr className="lg-hr" />
      <p>
        <Link to="/legal">All legal pages</Link> {"\u00b7 "}
        <Link to="/">Back to InZoRAH</Link>
      </p>
      <Foot />
    </main>
  );
};
